import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";


export interface IAddress {
    address_line_1: string;
    address_line_2: string;
    zip: string;
    city: string;
    state: string;
  }
  
export interface IAuthState {
    account_type: string|undefined;
    address: IAddress |undefined;// JSON string that will be parsed
    authorize_customer_id: string | null;
    company_name: string|undefined;
    created_ts: string|undefined;
    customer_profile_id: string | null;
    email: string|undefined;
    id: number|undefined;
    image: string|undefined;
    is_active: number;
    is_verified: number;
    first_name: string|undefined;
    last_name: string|undefined;
    membership_plan: string|undefined;
    order_status: string|undefined;
    phone: string|undefined;
    stripe_customer_id: string|undefined;
    tax_exemption: number;
    token: string|undefined;
    updated_ts: string|undefined;
    isLoggedIn: boolean;
}


interface StoreState {
  state: IAuthState;
  update: (args: IAuthState) => void;
}


export const authIntialState: IAuthState = {
    isLoggedIn: false,
    account_type: undefined,
    address: undefined,
    authorize_customer_id: null,
    company_name: undefined,
    created_ts: undefined,
    customer_profile_id: null,
    email:undefined,
    first_name: undefined,
    id: undefined,
    image: undefined,
    is_active: 0,
    is_verified: 0,
    last_name: undefined,
    membership_plan: undefined,
    order_status: undefined,
    phone: undefined,
    stripe_customer_id: undefined,
    tax_exemption: 0,
    token: undefined,
    updated_ts:undefined,
};
  

export const authStore = create<StoreState>()(
  persist(
    (set) => ({
      state: authIntialState,
      update: (args: IAuthState) =>
        set({ state: args || JSON.parse(localStorage.getItem("authData") || "{}") }),
    }),
    {
      name: "auth-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
